import React, { useContext, useState, useEffect, useRef } from 'react';
import forgeticon1 from '../../../Assets/Images/forgeticon1.png'
import { LangContext, FormForgetPassConfirmCode } from '../../../App'
import String from '../../../Assets/Localization/Local'
import { Modal, InputGroup, FormControl, Container, Row, Col, Button } from 'react-bootstrap'
import { useForm, Controller } from "react-hook-form";
import './ForgetPassword.css'
import { API_ENDPOINT } from '../../../AppConfig';
import axios from 'axios';
import ConfirmCode from './ConfirmCode'
import Snackbar from '@material-ui/core/Snackbar';

const Phonenumber = (props) => {

  const { lang } = useContext(LangContext)
  const [show, setShow] = useState(true);
  const [data, setData] = useState();
  const [open, setOpen] = React.useState(false);
  const [error, setErrorSnakbar] = React.useState(null);
  const { openFormConfirmCode, ToggleForm_forgetPass_ConfirmCode } = useContext(FormForgetPassConfirmCode)
  String.setLanguage(lang);

  const { register, handleSubmit, errors, control, watch, setValue, getValues } = useForm({
    // validationSchema: props.validation
  });


  useEffect(() => {
    console.log('openFormConfirmCode==> ', openFormConfirmCode)
    if (openFormConfirmCode === true) {
      setShow(false)
    }
  })
  // const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  const onSubmit = (data) => {
    console.log('data==>>> ', data)
    setData(data)
    let uri = `${API_ENDPOINT}/phoneForgetPassword`
    let SubmitData = {}
    SubmitData.phone = data.phone
    axios.post(uri, SubmitData, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      console.log('forgetPass done=> ', response.data)
      ToggleForm_forgetPass_ConfirmCode()
      // console.log('openFormConfirmCode=> ', openFormConfirmCode)

    }).catch(error => {
      console.log('forgetPass error=> ', error.response)
      setOpen(true);
        if (!error.response) {
          setErrorSnakbar("Network Error")
        }
        else if (error.response.status === 422) {
          for (let i = 0; i < error.response.data.errors.length; i++) {
            setErrorSnakbar(error.response.data.errors[i].msg)
          }
        }
        else {
          setErrorSnakbar(error.response.data.errors)
        }
    })
  }
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false)
  };
  return (
    <div>
      <div style={{ width: "100%", position: "absolute", bottom: "0px" }}>
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} message={error} />
      </div>
      <Modal className="forgetmodal text-center" show={show} onHide={props.close} animation={false}>
        <Modal.Header className="justify-content-center pb-0">
          <h3 className="text-white mt-5">{String.forgetpassword}</h3>
          <i style={{ left: lang === "ar" ? "10px" : "", right: lang === "en" ? "10px" : "" }} onClick={props.close} className="fa fa-close closeBTN"></i>
        </Modal.Header>
        <Modal.Body className="text-center">
          <div className="imgforgetcontainer">
            <img src={forgeticon1} alt="deleteimg" />
          </div>
          <h5>{String.enterphonenum}</h5>
          <form onSubmit={handleSubmit(onSubmit)} style={{ maxWidth: '100%', position: 'relative' }}>
            <Row>
              <Col lg='12' style={{ marginBottom: '40px' }}>
                <div className="textWithIcon"  >

                  <input type="text" name="phone" ref={register} placeholder={String.PhoneNum} className="textStyleWithIcon px-4" style={{ direction: lang === "ar" ? 'rtl' : 'ltr' }} />

                  <span className="TextFieldIcon" style={{ right: lang === 'en' ? '1.5rem' : '', left: lang === 'ar' ? '1.5rem' : '' }}>
                    <i className="fas fa-mobile-alt fa-2x"> </i>
                  </span>

                </div>
                {/* {errors[element.name] && <p className="ErrorStyle">{errors[element.name]["message"]}</p>} */}
              </Col>
            </Row>
            <button className="btn nextBTN btn-block mb-4" type="submit"> {String.next} </button>
          </form>
        </Modal.Body>
      </Modal>
      {openFormConfirmCode && <ConfirmCode close={ToggleForm_forgetPass_ConfirmCode} phone={data} />}
    </div >
  );
}

export default Phonenumber;

